import { createFileRoute } from '@tanstack/react-router';

import { scratchpadDetailSearchSchema } from '@apps/web/features/admin_agent_scratchpad/model/search_params';
import { ScratchpadNoteDetailPage } from '@apps/web/features/admin_agent_scratchpad/ui/note_detail_page';

export const Route = createFileRoute(
    '/_app/admin/agent/(notes)/notes/$note-id',
)({
    component: ScratchpadNoteDetailRoute,
    validateSearch: scratchpadDetailSearchSchema,
    head: () => ({
        meta: [{ title: 'Note | Internal Admin Agent' }],
    }),
});

function ScratchpadNoteDetailRoute() {
    const params = Route.useParams();
    const search = Route.useSearch();
    return (
        <ScratchpadNoteDetailPage noteId={params['note-id']} search={search} />
    );
}
